import { JSX } from 'preact'
import { useCustomMedia } from '../useCustomMedia'
import { useComponentStyle } from '../Style'
import classNames from 'classnames'
import { previewProps } from '../../preview'
import { resolveMedia } from '../../helpers/resolve-media'
import { BlockType, TBlockProps } from '@gsc/types'

export const Picture = (props: TBlockProps<BlockType.Picture>): JSX.Element => {
  const customMedia = useCustomMedia()
  const { classes } = useComponentStyle('picture', props)

  const { sources = [], src, id } = props

  return (
    <picture className={classNames(classes)} {...previewProps(BlockType.Picture, id)}>
      {sources.map((s, i) => (
        <source key={i} srcSet={s.srcSet} media={resolveMedia(s.media, customMedia)} />
      ))}
      <img src={src} />
    </picture>
  )
}
